import { Component, AfterViewInit, input, OnDestroy } from '@angular/core';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { FieldType } from '@ngx-formly/core';
import { StepDefinition } from '../dynamic';
import { ContextService, LayoutInterface } from '../../context.service';
import { LayoutComponent } from '../../layout/layout.component';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'mutara-stepper',
  templateUrl: './stepper.component.html', providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true },
    },
  ],
  styleUrl: './stepper-header.component.scss',
  standalone: false
})
export class StepperComponent extends FieldType implements AfterViewInit, OnDestroy {
  index = input<number>(0);
  readonly isFixed = input<boolean>(false);
  stepDefinitions = input<StepDefinition[] | undefined>(undefined);
  selected = input(0);
  layout = input<LayoutComponent | undefined>(undefined);
  parentLayout = input<LayoutInterface | undefined | null>(undefined);

  isComplete: boolean = false;
  isVertical: boolean = false;

  constructor(private contextService: ContextService, private viewportScroller: ViewportScroller) {
    super();
    this.contextService.subscribeTo("orientation", (isVertical: boolean) => {
      this.isVertical = isVertical;
    });
  }

  ngAfterViewInit(): void {
    this.contextService.subscribeTo("stepIndex", (stepField: { layout: LayoutInterface, step: string }) => {
      if (!!stepField && stepField?.layout?.layoutId == this.parentLayout()?.layoutId) {
        const matchedStepIndex : number = this.stepDefinitions()?.findIndex(step => step.step == stepField.step) ?? 0;
        console.log('Stepper step %O (%O)', stepField, matchedStepIndex);
        this.selected.apply(matchedStepIndex);
      }
      this.reassignTabRole();
    });
  }

  ngOnDestroy(): void {
    this.stepDefinitions.apply([]);
    this.layout.apply(null);
  }

  _lookForVisibleChildren(stepToCheck: StepDefinition): boolean {
    let hasVisible = true;
    if (!!stepToCheck.fieldDefinitions) {
      if ((stepToCheck?.fieldDefinitions.length ?? -1) > 0) {
        hasVisible = false;
        stepToCheck.fieldDefinitions.forEach(fldDefn => {
          hasVisible ||= !fldDefn.hide;
        });
      }
    }
    return hasVisible;
  }

  /** TBD move to template for HORIZONTAL  */
  reassignTabRole() {
    let stepperHeaderContainers = document.getElementsByClassName('mat-horizontal-stepper-header-container');
    if (stepperHeaderContainers.length > 0) {
      stepperHeaderContainers[0].setAttribute('role', 'tablist');
      stepperHeaderContainers[0].setAttribute('aria-label', 'Steps in the application process');
    }
    let steppers = document.querySelectorAll('.stepper-orientation, mat-stepper');
    steppers.forEach(stepper => {
      stepper.removeAttribute('aria-orientation');
    });
  }


  get firstStep(): StepDefinition {
    return this.visibleDefinitions[0];
  }

  get visibleDefinitions(): StepDefinition[] {
    return this.stepDefinitions()?.filter(defn => this.isStepVisible(defn)) ?? [];
  }

  // We are changing the step which will clear the highlight if set
  setStep($event: any) {
    if (this.selected != $event.selectedIndex) {
      this.contextService.setStepIndex(this.parentLayout(), this.stepDefinitions()?.[$event.selectedIndex].step);
      // setTimeout( () => this.contextService.updateValidity(), 0);

      //this.selected.apply($event.selectedIndex);
      this.viewportScroller.scrollToPosition([0,0]);
    } else {
      this.reassignTabRole();
    }
  }

  isStepVisible(step: any): boolean {
    return this._evaluateVisible(step?.isVisible) && this._lookForVisibleChildren(step);
  }

  isRequired(step: any): boolean {
    return this._evaluateVisible(step?.isRequired);
  }


  _evaluateVisible(toEvaluate: any, defaultValue: boolean = true): boolean {
    let isTrue: boolean = false;
    // If there is something to valuate, isTrue will get set
    if (!!toEvaluate) {
      isTrue = ['1', 'true', true, 1].includes(toEvaluate?.toLowerCase() ?? toEvaluate);
      if (typeof toEvaluate === 'string' && !isTrue) {
        try {
          isTrue = eval(toEvaluate);
        } catch (error) {
          console.debug('Unable to evaluate: %O\n%O', toEvaluate, error);
          isTrue = defaultValue;
        }
      }
    }
    return isTrue ?? defaultValue;
  }
}